import { render, staticRenderFns } from "./OrgReporting.vue?vue&type=template&id=62537cdd&scoped=true&"
import script from "./OrgReporting.vue?vue&type=script&lang=js&"
export * from "./OrgReporting.vue?vue&type=script&lang=js&"
import style0 from "./OrgReporting.vue?vue&type=style&index=0&id=62537cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62537cdd",
  null
  
)

export default component.exports